export const SUPPORT_ARTICLE_SLUGS = {
  // Phase 1 — clinical reference
  cptCodingGuide: 'cpt-coding-guide',
  psychiatryDocumentationGuide: 'psychiatry-documentation-guide',
  therapyDocumentationGuide: 'therapy-documentation-guide',
  formulary: 'formulary',
  prescribingPolicy: 'prescribing-policy',
  // Phase 2 — getting started
  gettingStarted: 'getting-started',
  // Phase 2 — sessions
  joinASession: 'join-a-session',
  manageSessions: 'manage-sessions',
  missedSessionsPolicy: 'missed-sessions-policy',
  // Phase 2 — calendar
  importGoogleCalendar: 'import-google-calendar',
  exportUpliftCalendar: 'export-uplift-calendar',
  // Phase 2 — matching
  matchingAvailability: 'matching-availability',
  changeAvailability: 'change-availability',
  matchingProfile: 'matching-profile',
  profilePicture: 'profile-picture',
  getClients: 'get-clients',
  directories: 'directories',
  // Phase 2 — payments
  getPaid: 'get-paid',
  directDeposit: 'direct-deposit',
  paySchedule: 'pay-schedule',
  // Phase 2 — technical
  resetPassword: 'reset-password',
  cameraChrome: 'camera-chrome',
  cameraSafari: 'camera-safari',
  cameraEdge: 'camera-edge',
  // Phase 2 — onboarding
  afterSigningContract: 'after-signing-contract',
  upliftTraining: 'uplift-training',
  signedContract: 'signed-contract',
  credentialing: 'credentialing',
  // Phase 3 — documentation
  documentationChartsIntro: 'documentation-charts-intro',
  progressNotes: 'progress-notes',
  communicationNote: 'communication-note',
  documentCenter: 'document-center',
  intakeForms: 'intake-forms',
  consentForms: 'consent-forms',
  dischargeClient: 'discharge-client',
  reactivateClient: 'reactivate-client',
  // Phase 3 — assessments
  phq9: 'phq-9',
  gad7: 'gad-7',
  pcl5: 'pcl-5',
  suicideRisk: 'suicide-risk',
  // Phase 3 — psychiatry
  psychiatryServices: 'psychiatry-services',
  referToPsychiatrist: 'refer-to-psychiatrist',
  contactPsychiatrist: 'contact-psychiatrist',
  reviewPsychiatryNotes: 'review-psychiatry-notes',
  chartReviews: 'chart-reviews',
  supervisedNps: 'supervised-nps',
  supervisionMeeting: 'supervision-meeting',
  // Phase 3 — reference / policies / general
  therapyCptCodes: 'therapy-cpt-codes',
  telehealthAppropriateness: 'telehealth-appropriateness',
  betterhelpRebrandFaq: 'betterhelp-rebrand-faq',
} as const;

export type SupportArticleSlug = typeof SUPPORT_ARTICLE_SLUGS[keyof typeof SUPPORT_ARTICLE_SLUGS];

export type SupportArticleCategory =
  | 'getting-started'
  | 'onboarding'
  | 'sessions'
  | 'calendar'
  | 'matching'
  | 'payments'
  | 'technical'
  | 'documentation'
  | 'assessments'
  | 'psychiatry'
  | 'reference'
  | 'policies'
  | 'general';

export const SUPPORT_ARTICLE_CATEGORY_LABELS: Record<SupportArticleCategory, string> = {
  'getting-started': 'Getting Started',
  'onboarding': 'Onboarding',
  'sessions': 'Sessions',
  'calendar': 'Calendar',
  'matching': 'Matching & Availability',
  'payments': 'Payments',
  'technical': 'Technical Support',
  'documentation': 'Documentation & Charts',
  'assessments': 'Assessments',
  'psychiatry': 'Psychiatry Services',
  'reference': 'Clinical Reference',
  'policies': 'Policies',
  'general': 'General',
};

export const SUPPORT_ARTICLE_CATEGORY_DESCRIPTIONS: Record<SupportArticleCategory, string> = {
  'getting-started': 'Go live and learn the basics of using BetterHelp.',
  'onboarding': 'Contracts, training, and credentialing steps.',
  'sessions': 'Join sessions, manage your schedule, and missed-session policy.',
  'calendar': 'Import Google Calendar and export your BetterHelp calendar.',
  'matching': 'Availability, matching profile, and getting clients.',
  'payments': 'Direct deposit setup and when you get paid.',
  'technical': 'Password reset and camera/mic permissions.',
  'documentation': 'Notes, charts, forms, document center, and discharge.',
  'assessments': 'PHQ-9, GAD-7, PCL-5, and suicide risk assessment.',
  'psychiatry': 'Psychiatry services, referrals, chart reviews, supervision, and care team collaboration.',
  'reference': 'CPT codes, documentation guides, formulary, and prescribing.',
  'policies': 'Telehealth appropriateness and clinical policy guidelines.',
  'general': 'Company updates and frequently asked questions.',
};

export const SUPPORT_ARTICLE_CATEGORY_ORDER: SupportArticleCategory[] = [
  'getting-started',
  'onboarding',
  'sessions',
  'calendar',
  'matching',
  'payments',
  'documentation',
  'assessments',
  'psychiatry',
  'reference',
  'technical',
  'policies',
  'general',
];
